import src from "IMAGE";
export default { src, width: 664, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARElEQVR42iWKuQ3AIAAD7ZIiiaKEPECBaOjZgJoxWIehsURxsuUzWkwjbHsl+Ih3JS6STlgUH/phTNZ4S37rhFPyV7cTn8sDxekXkcEAAAAASUVORK5CYII="};
